// extracted by mini-css-extract-plugin
export default {"cardWrapper":"FDeRp_A9H55PNJ74iAuRX"};